/* RN WebView 양방향 통신 브릿지 */

let _webReadySent = false;

export function isInRnWebView() {
  return !!(window.ReactNativeWebView);
}

export function postToRN(type, payload = {}) {
  if (!isInRnWebView()) return;
  window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
}

export function listenWebviewMessages(handler) {
  const listener = (e) => {
    try {
      const msg = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
      if (msg.payload && typeof msg.payload === "object") {
        handler({ ...msg.payload, type: msg.type });
      } else {
        handler(msg);
      }
    } catch {
      // ignore non-JSON
    }
  };
  window.addEventListener("message", listener);
  document.addEventListener("message", listener);
  return () => {
    window.removeEventListener("message", listener);
    document.removeEventListener("message", listener);
  };
}

export function requestNativeSocialSignIn(provider) {
  return new Promise((resolve, reject) => {
    const off = listenWebviewMessages((msg) => {
      if (msg.type === "SIGNIN_RESULT") {
        off();
        if (msg.error) reject(new Error(msg.error));
        else resolve(msg);
      }
    });
    postToRN("START_SIGNIN", { provider });
    setTimeout(() => { off(); reject(new Error("Social sign-in timeout")); }, 30000);
  });
}

export function requestNativeSignOut() {
  postToRN("START_SIGNOUT");
}

export function sendWebReadyOnce() {
  if (_webReadySent) return;
  _webReadySent = true;
  postToRN("WEB_READY");
}

export function waitForRnMessage(type, timeoutMs = 10000) {
  return new Promise((resolve, reject) => {
    const off = listenWebviewMessages((msg) => {
      if (msg.type === type) { off(); resolve(msg); }
    });
    setTimeout(() => { off(); reject(new Error(`Timeout waiting for ${type}`)); }, timeoutMs);
  });
}

export function sendNavState(path) {
  postToRN("NAV_STATE", { path });
}

// FCM 토큰 요청 (RN에게 토큰 달라고 요청)
export function requestPushToken() {
  const ok = postToRN("GET_PUSH_TOKEN");
  appendRnLog(ok ? "📤GET_PUSH_TOKEN(요청성공)" : "❌GET_PUSH_TOKEN(RN없음)", []);
  return ok;
}

// 디버그 로그 (sessionStorage 순환 버퍼)
export function appendRnLog(type, keys, tokenHint) {
  try {
    const prev = JSON.parse(sessionStorage.getItem("__rnLogs") || "[]");
    prev.push({ type, keys: keys || [], t: new Date().toLocaleTimeString(), tokenHint: tokenHint || "" });
    if (prev.length > 20) prev.shift();
    sessionStorage.setItem("__rnLogs", JSON.stringify(prev));
  } catch {}
}

// PUSH_TOKEN 메시지 수신 리스너 등록
export function onPushToken(callback) {
  return listenWebviewMessages((msg) => {
    if (msg.type === "PUSH_TOKEN" && msg.token) {
      callback(msg.token, msg.platform || 'android');
    }
  });
}
